$(document).ready(function initFacetSearch() {
  // Define the facet types to add search functionality to
  const facetTypes = ["Search OEM Part Numbers", "Manufacturer", "Collections"];

  // Create a global object to expose functionality for all facet types
  window.FacetSearch = {};
  
  // Store initializations to avoid duplicates
  const initializedFacets = new Set();

  // Function to check if facet search is already initialized
  function isSearchInitialized(facetDetails) {
    return facetDetails.querySelector('.facet-search-container') !== null;
  }
  
  // Create a mutation observer to watch for DOM changes
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList' || mutation.type === 'subtree') {
        // Check if our facet types need to be re-initialized
        facetTypes.forEach(facetType => {
          const facetDetails = document.querySelector(`details summary[aria-label*="${facetType}"]`)?.closest("details");
          if (facetDetails && !isSearchInitialized(facetDetails)) {
            const facetInterface = initializeFacetSearch(facetType);
            if (facetInterface) {
              window.FacetSearch[facetType] = facetInterface;
            }
          }
        });
      }
    });
  });

  // Initialize observer to watch the entire document
  observer.observe(document.body, { 
    childList: true, 
    subtree: true 
  });

  // Initial setup
  facetTypes.forEach((facetType) => {
    const facetInterface = initializeFacetSearch(facetType);
    if (facetInterface) {
      window.FacetSearch[facetType] = facetInterface;
    }
  });

  // Clear OEM search from session storage on page load
  const oemStorageKey = `facetSearch_Search_OEM_Part_Numbers`;
  sessionStorage.removeItem(oemStorageKey);

  // Function to initialize search for a specific facet type
  function initializeFacetSearch(facetType) {
    // Find the details element for this facet type
    const facetDetails = document
      .querySelector(`details summary[aria-label*="${facetType}"]`)
      ?.closest("details");

    if (!facetDetails) {
      console.log(`${facetType} facet not found`);
      return null;
    }

    // Check if search is already initialized for this facet
    if (isSearchInitialized(facetDetails)) {
      return window.FacetSearch[facetType]; // Return existing interface
    }

    // Create the search input container
    const searchContainer = document.createElement("div");
    searchContainer.className = `facet-search-container ${facetType.toLowerCase()}-search-container`;
    searchContainer.style.cssText = "border-bottom: 1px solid #e0e0e0;";

    // Create the search input
    const searchInput = document.createElement("input");
    searchInput.type = "text";// Set appropriate placeholder text
    if (facetType === "Search OEM Part Numbers") {
      searchInput.placeholder = `Search OEM part numbers...`;
    } else {
      searchInput.placeholder = `Search ${facetType.toLowerCase()}...`;
    }
    searchInput.className = `facet-search-input ${facetType.toLowerCase()}-search-input`;
    searchInput.dataset.facetType = facetType; // Store facet type in dataset
    searchInput.style.cssText =
      "width: 100%; padding: 8px; border: 1px solid #ccc; border-radius: 4px; font-size: 14px;";

    // Add the input to the container
    searchContainer.appendChild(searchInput);

    // Insert the search container right after the summary element
    const summary = facetDetails.querySelector("summary");
    if (summary && summary.nextSibling) {
      facetDetails.insertBefore(searchContainer, summary.nextSibling);
    } else {
      facetDetails.appendChild(searchContainer);
    }

    // Search function for this facet
    function performSearch() {
      const searchTerm = searchInput.value.toLowerCase().trim();
      const isOEMSearch = facetType === "Search OEM Part Numbers";

      // Always refresh the list of items to ensure we're working with the current DOM
      const currentItems = facetDetails.querySelectorAll(".facets__item");
      
      // For OEM search, only show suggestions if search text is longer than 1 character
      if (isOEMSearch) {
        const facetsLayout = facetDetails.querySelector(".facets-layout");
        if (facetsLayout) {
          if (searchTerm.length <= 1) {
            facetsLayout.style.display = "none";
          } else {
            facetsLayout.style.display = "";
          }
        }
      }

      // Filter items based on search term
      currentItems.forEach((item) => {
        const label = item.querySelector(".facet-checkbox__text-label");
        if (!label) return;

        const itemName = label.textContent.toLowerCase();

        // Special handling for OEM Part Numbers
        if (isOEMSearch && searchTerm.length <= 1) {
          item.style.display = "none";
          return;
        }

        if (searchTerm === "") {
          // When search is empty, restore original state
          if (item.classList.contains("show-more-item")) {
            item.classList.add("hidden");
            item.style.display = ""; // Reset to default
          } else {
            item.style.display = ""; // Reset to default
          }
        } else if (itemName.includes(searchTerm)) {
          // Item matches search - show it
          item.style.display = "block";
          item.classList.remove("hidden"); // Remove hidden class during search
        } else {
          // No match - hide with display:none
          item.style.display = "none";
        }
      });

      // Control "Show more" button visibility
      const showMoreButton = facetDetails.querySelector(".button-show-more");
      if (showMoreButton) {
        showMoreButton.style.display = searchTerm ? "none" : "";
      }

      // Show a "no results" message if needed
      let noResultsMsg = facetDetails.querySelector(".no-results-message");
      const hasMatches = Array.from(currentItems).some((item) => {
        const label = item.querySelector(".facet-checkbox__text-label");
        return label && label.textContent.toLowerCase().includes(searchTerm);
      });

      // Only show no results message for OEM search if search term > 1 character
      if (searchTerm && !hasMatches && (!isOEMSearch || searchTerm.length > 1)) {
        if (!noResultsMsg) {
          noResultsMsg = document.createElement("div");
          noResultsMsg.className = "no-results-message";
          noResultsMsg.textContent = `No ${facetType.toLowerCase()} found`;
          noResultsMsg.style.cssText =
            "padding: 10px; color: #777; text-align: center;";
          searchContainer.after(noResultsMsg);
        }
        noResultsMsg.style.display = "block";
      } else if (noResultsMsg) {
        noResultsMsg.style.display = "none";
      }
    }

    // Add event listeners for filtering with event prevention
    searchInput.addEventListener("input", function (e) {
      e.stopPropagation();
      performSearch();
    });

    // Also handle the Enter key
    searchInput.addEventListener("keydown", function (event) {
      if (event.key === "Enter") {
        event.preventDefault();
        event.stopPropagation();
        performSearch();
      }
    });

    // Make sure the details element is open when searching
    searchInput.addEventListener("focus", function (e) {
      e.stopPropagation();
      facetDetails.open = true;
    });

    // Add a clear button for better UX
    const clearButton = document.createElement("button");
    clearButton.textContent = "Clear";
    clearButton.type = "button"; // Explicitly set type to avoid form submission
    clearButton.className = `facet-clear-btn ${facetType.toLowerCase()}-clear-btn`;
    clearButton.style.cssText =
      "position: absolute; right: 10px; top: 50%; transform: translateY(-50%); " +
      "background: none; border: none; cursor: pointer; color: #777; " +
      "display: none;";

    // Position the clear button correctly
    searchContainer.style.position = "relative";
    searchContainer.appendChild(clearButton);

    // Show/hide clear button based on search input
    searchInput.addEventListener("input", function () {
      clearButton.style.display = searchInput.value ? "block" : "none";
    });

    // Clear search when button is clicked
    clearButton.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
      searchInput.value = "";
      clearButton.style.display = "none";
      performSearch();
      searchInput.focus();
    });

    // Disconnect the input from any potential parent forms to prevent submission
    if (searchInput.form) {
      searchInput.form.addEventListener(
        "submit",
        (e) => {
          // If our search input has value, prevent form submission
          if (searchInput === document.activeElement || searchInput.value) {
            e.preventDefault();
            e.stopPropagation();
          }
        },
        true
      );
    }

    // Prevent checkboxes inside this facet from causing a page reload
    facetDetails.querySelectorAll('input[type="checkbox"]').forEach(checkbox => {
      checkbox.addEventListener('change', function(e) {
        // Allow the event to propagate, but store the search input value
        // We'll focus on handling the DOM mutation instead
      });
    });

    // Initialize with the facet details open for better UX (optional)
    facetDetails.open = true;

    // Maintain persistence in sessionStorage
    const storageKey = `facetSearch_${facetType.replace(/\s+/g, '_')}`;
    
    // Restore any previous search term (but not for OEM search)
    if (facetType !== "Search OEM Part Numbers") {
      const savedSearch = sessionStorage.getItem(storageKey);
      if (savedSearch) {
        searchInput.value = savedSearch;
        performSearch();
        clearButton.style.display = searchInput.value ? "block" : "none";
      }
    }
    
    // Save search term when it changes
    searchInput.addEventListener('input', function() {
      // Only save to session storage for non-OEM searches
      if (facetType !== "Search OEM Part Numbers") {
        sessionStorage.setItem(storageKey, searchInput.value);
      }
    });

    // Special initialization for OEM search - hide suggestions initially
    if (facetType === "Search OEM Part Numbers") {
      // Always clear the OEM search input on initialization
      searchInput.value = "";
      
      const facetsLayout = facetDetails.querySelector(".facets-layout");
      if (facetsLayout) {
        facetsLayout.style.display = "none";
      }
    }

    return {
      element: facetDetails,
      searchInput: searchInput,

      // Helper function to select a specific item in this facet
      selectItem: function (name) {
        if (!facetDetails) return false;

        const checkboxes = facetDetails.querySelectorAll(
          'input[type="checkbox"]'
        );

        const checkbox = Array.from(checkboxes).find((cb) => {
          const label = cb.closest("label");
          return (
            label &&
            label.textContent.toLowerCase().includes(name.toLowerCase())
          );
        });

        if (checkbox) {
          checkbox.checked = true;
          // Trigger change event to activate filtering
          checkbox.dispatchEvent(new Event("change", { bubbles: true }));
          return true;
        }

        return false;
      },

      // Helper function to clear all selected items in this facet
      clearFilters: function () {
        if (!facetDetails) return;

        const checkboxes = facetDetails.querySelectorAll(
          'input[type="checkbox"]:checked'
        );
        checkboxes.forEach((checkbox) => {
          checkbox.checked = false;
          checkbox.dispatchEvent(new Event("change", { bubbles: true }));
        });
      },

      // Helper function to get all available items in this facet
      getAvailableItems: function () {
        if (!facetDetails) return [];

        const itemLabels = facetDetails.querySelectorAll(
          ".facet-checkbox__text-label"
        );
        return Array.from(itemLabels).map((label) => {
          const name = label.textContent.trim();
          const count =
            label
              .closest(".facet-checkbox__text")
              ?.textContent.match(/\((\d+)\)/)?.[1] || 0;
          return { name, count: parseInt(count, 10) };
        });
      },
      
      // Refresh the search functionality
      refresh: function() {
        // For OEM search, always clear the input on refresh
        if (facetType === "Search OEM Part Numbers") {
          searchInput.value = "";
        }
        performSearch();
      }
    };
  }

  // Re-run initialization when URL changes (this handles the back button)
  window.addEventListener('popstate', function() {
    // Clear OEM search from session storage when navigating
    const oemStorageKey = `facetSearch_Search_OEM_Part_Numbers`;
    sessionStorage.removeItem(oemStorageKey);
    
    facetTypes.forEach(facetType => {
      if (window.FacetSearch[facetType]) {
        window.FacetSearch[facetType].refresh();
      } else {
        const facetInterface = initializeFacetSearch(facetType);
        if (facetInterface) {
          window.FacetSearch[facetType] = facetInterface;
        }
      }
    });
  });

  // Add event listener for page beforeunload to clear OEM search
  window.addEventListener('beforeunload', function() {
    const oemStorageKey = `facetSearch_Search_OEM_Part_Numbers`;
    sessionStorage.removeItem(oemStorageKey);
  });

  console.log("Facet search functionality initialized for:", facetTypes);
});